<template>
  <div class="case-spisi kalendar-page">
    <div class="kalendar-left">
      <div class="opening-folder kalendar-wrapper">
        <div class="open-folder-line">
          <div class="open-folder-line-left">
            <div class="kalendar-page-dropdown">
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="computed_date" label="" append-icon="mdi-calendar" v-bind="attrs"
                    @click="menu = !menu" v-on="on" class="calendar-date-picker" color="#3326ae" readonly>
                  </v-text-field>
                </template>
                <v-date-picker locale="hr" :first-day-of-week="1" color="#3326ae" type="month" v-model="chosen_date"
                  @change="menu = !menu; changeDate();"></v-date-picker>
              </v-menu>
            </div>
            <div class="shift-months">
              <div class="kalendar-prev" @click="prevMonth()">
                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13">
                  <g>
                    <g>
                      <path fill="none" stroke="#1e33f2" stroke-miterlimit="20" stroke-width="2"
                        d="M6.421 11.72v0L1.28 6.579v0L6.42 1.438v0" />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="kalendar-next" @click="nextMonth()">
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="13" viewBox="0 0 8 13">
                  <g>
                    <g>
                      <path fill="none" stroke="#1e33f2" stroke-miterlimit="20" stroke-width="2"
                        d="M.83 11.72v0l5.14-5.141v0L.83 1.438v0" />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="open-folder-line-right">
            <div v-if="$route.name == 'CalendarGeneral'" style="margin-right: 0.5rem;" class="posta-dropdown">
              {{ $t("components.calendar.filter") }}:
              <select class="drop-filter" id="search-group multiple" v-model="select_source_type">
                <option v-for="(ev_type, key) in source_types" :key="key" :value="ev_type.id">{{ ev_type.naziv }}
                </option>
              </select>
              <!-- <input type="submit" value="Submit" /> -->
              <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
            </div>
            <div v-if="$route.name == 'Calendar'" class="generiraj-rocisnik-button" @click="generateReport">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
                <path d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297" stroke="#2B2B41"
                  stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <circle cx="17.9954" cy="3.20027" r="1.9222" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788"
                  stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span>{{ $t("components.calendar.generate_report")}}</span>
            </div>
            <div v-if="$route.name == 'Calendar'" class="vertical-divider"></div>
            <div class="posta-dropdown">
              {{ $t("components.calendar.filter")}}:
              <select class="drop-filter" id="search-group multiple" v-model="select_event_type">
                <option v-for="(ev_type, key) in filter_event_type" :key="key" :value="ev_type.id">{{ ev_type.naziv }}
                </option>

              </select>
              <!-- <input type="submit" value="Submit" /> -->
              <img class="calendar-arrow" src="@/assets/img/strelica_dupla.svg" />
            </div>
          </div>
        </div>
        <div class="kalendar">
          <div class="kalendar-daysofweek">
            <div class="kalendar-dayofweek"> {{ $t("components.calendar.days_of_week.d1") }}</div>
            <div class="kalendar-dayofweek">{{ $t("components.calendar.days_of_week.d2") }}</div>
            <div class="kalendar-dayofweek">{{ $t("components.calendar.days_of_week.d3") }}</div>
            <div class="kalendar-dayofweek">{{ $t("components.calendar.days_of_week.d4") }}</div>
            <div class="kalendar-dayofweek">{{ $t("components.calendar.days_of_week.d5") }}</div>
            <div class="kalendar-dayofweek">{{ $t("components.calendar.days_of_week.d6") }}</div>
            <div class="kalendar-dayofweek">{{ $t("components.calendar.days_of_week.d7") }}</div>
          </div>
          <div class="kalendar-day-grid">
            <div v-if="fetching" class="center-spinner">
              <svg class="dot-spin" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
              </svg>
            </div>
            <div v-else v-for="(dan, key) in raspon_datuma" :key="key" :class="dan.classes"
              @click="updateClickedClass(key)" @dblclick="openCreateEvent(dan)">
              {{ dan.dan_enum }}
              <div class="today-events">

                <div v-for="(added_class, key) in dan.added_classes.slice(0, 6)" :key="key"
                  :class="'dot d-' + added_class"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Close spisi-left -->
    <div class="spisi-right kalendar-right">
      <div class="kalendar-info">
        <div style="display:flex">
          <div class="kalendar-info-text">{{ shown_date }}</div>
          <div class="shift-days">
            <div class="kalendar-day-prev"
              @click="kategorija_liste == 3 ? prevMonth() : kategorija_liste == 1 ? prevDay() : prevWeek()">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13">
                <g>
                  <g>
                    <path fill="none" stroke="#606076" stroke-miterlimit="20" stroke-width="2"
                      d="M6.421 11.72v0L1.28 6.579v0L6.42 1.438v0" />
                  </g>
                </g>
              </svg>
            </div>
            <div class="kalendar-day-next"
              @click="kategorija_liste == 3 ? nextMonth() : kategorija_liste == 1 ? nextDay() : nextWeek()">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13">
                <g>
                  <g>
                    <path fill="none" stroke="#606076" stroke-miterlimit="20" stroke-width="2"
                      d="M.83 11.72v0l5.14-5.141v0L.83 1.438v0" />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
        <div class="kalendar-info-wrapper">
          <div class="kalendar-info-dnevni" v-bind:class="[kategorija_liste == 1 ? 'active' : '']"
            @click="kategorija_liste = 1">
            {{ $t("components.calendar.span_filter.f1") }}
          </div>
          <div class="kalendar-info-tjedni" v-bind:class="[kategorija_liste == 2 ? 'active' : '']"
            @click="kategorija_liste = 2">
            {{ $t("components.calendar.span_filter.f2") }}
          </div>
          <div class="kalendar-info-mjesecni" v-bind:class="[kategorija_liste == 3 ? 'active' : '']"
            @click="kategorija_liste = 3">
            {{ $t("components.calendar.span_filter.f3") }}
          </div>
        </div>
      </div>
      <div class="events-pagination-wrapper">
        <EventCard v-for="(single_event, key) in finalni_arr_prikaza" v-bind:key="key" :single_event="single_event"
          :project_event="$route.name == 'KalendarProject' && single_event.event_type.uid == 1 ? true : false" />
        <div v-if="rasporedi_liste[kategorija_liste - 1].length == 0" class="case-kalendar-event-empty">
          {{ $t("components.calendar.no_events") }}</div>
      </div>
      <Pagination v-show="rasporedi_liste[kategorija_liste - 1].length != 0" ref="paginat" :finalni_arr_prikaza.sync="finalni_arr_prikaza" :br_redova="br_redova" :ukupna_lista="rasporedi_liste[kategorija_liste - 1]"/>
    </div>
    <!-- <CalendarModal 
            v-if="popup_open"
              :se="chosen_event"
              @popup_close="closePopup()"
            >
            </CalendarModal> -->
  </div>
</template> 

<script>
import moment from "moment"
import auth from "@/services/auth"
import person from "@/apiCallers/promise_handler_db/person"
import ms_calendar from "@/apiCallers/promise_handler_db/calendarSharepoint"
import CaseTab from "@/components/caseComponents/CaseTab.vue"
import CalendarModal from "@/components/calendarComponents/CalendarModal.vue"
import EventCard from "@/components/calendarComponents/EventCard.vue"
import permissioner from "@/services/permissioner.js"
import gsap from "gsap"
import Pagination from "@/components/generalComponents/Pagination.vue";


export default {
  components: { CaseTab, CalendarModal, EventCard, Pagination},

  data: function () {
    return {
      selected_month: moment().month(),
      accessToken: "",
      //dnevni - idx0, tjedni - idx1, mjesecni - idx2,
      rasporedi_liste: [[], [], []],
      filter_event_type: [
        { "naziv": this.$t("components.calendar.filter_event_type")[0].naziv, "id": 0 },
        { "naziv": this.$t("components.calendar.filter_event_type")[1].naziv, "id": 6 }
      ],
      select_event_type: 0,
      selected_year: moment().year(),
      raspon_datuma: [],
      current_day: moment().date(),
      chosen_date: moment().format("YYYY-MM"),
      shown_date: moment().format("DD.MM.YYYY."),
      menu: false,
      mjeseci:this.$t("components.calendar.months"),
      kategorija_liste: 1,
      br_redova: 4,
      popup_open: false,
      chosen_event: null,
      finalni_arr_prikaza: [],
      is_clicked_on_calendar: true,
      fetching: true,
      source_types: this.$t("components.calendar.source_types"),
      select_source_type: 0,
    };
  },
  watch: {
    current_day: function () {
      this.$store.state.event_details.selected_day = this.current_day;
    },
    select_event_type: async function () {
      this.$store.state.event_details.selected_type = this.select_event_type;
      await this.updateRasponDatuma();
      this.updateClickedClass(this.current_day);
      this.$refs.paginat.paginirajOdabrane();
    },
    select_source_type: async function () {
      await this.updateRasponDatuma();
      this.updateClickedClass(this.current_day);
      this.$refs.paginat.paginirajOdabrane();
    },
    kategorija_liste: function () {
      setTimeout(() => {
        this.$refs.paginat.calculatePageNumber();
        this.$refs.paginat.paginirajOdabrane();
      }, 10);
      switch (this.kategorija_liste) {
        case 1:
          this.raspon_datuma.forEach((dan) => {
            dan.classes = dan.classes.replaceAll("week", "");
            dan.classes = dan.classes.replaceAll("today", "");
          });
          this.selectDay(this.current_day);
          this.shown_date = moment(this.raspon_datuma[this.current_day].fullDate).format("DD.MM.YYYY")
          break;
        case 2:
          this.cleanClasses();
          var end_idx = 0;
          var start_idx = 0;
          var kvocijent = Math.floor(this.current_day / 7);
          start_idx = kvocijent * 7;
          end_idx = start_idx + 6;
          this.selectWeekRange(start_idx, end_idx);
          this.selectDay(this.current_day);
          break;
        case 3:
          this.cleanClasses();
          this.selectMonthRange();
          this.selectDay(this.current_day);
          break;
        default:
          break;
      }
    }
  },
  async created() {
    this.accessToken = this.$store.state.aToken;

    // Check if we have a pending event to auto-open (from Legal Assistant)
    const pendingEventId = this.$store.state.event_details.pending_event_id;
    const pendingEventDate = this.$store.state.event_details.pending_event_date;

    if (pendingEventId && pendingEventDate) {
      console.log('[CalendarComponent] Pending event detected:', { id: pendingEventId, date: pendingEventDate });

      // Parse the pending event date and navigate to that month
      const eventMoment = moment(pendingEventDate);
      this.chosen_date = eventMoment.format("YYYY-MM");
      this.selected_month = eventMoment.month();
      this.selected_year = eventMoment.year();

      // Clear pending event from store
      this.$store.state.event_details.pending_event_id = null;
      this.$store.state.event_details.pending_event_date = null;
    }

    await this.updateRasponDatuma();
    let first_day = this.raspon_datuma.findIndex(obj => obj.dan_enum == 1);

    if (pendingEventId && pendingEventDate) {
      // Find the day index for the pending event date
      const eventDay = moment(pendingEventDate).date();
      const dayIndex = this.raspon_datuma.findIndex(obj => obj.dan_enum == eventDay && obj.fullDate == pendingEventDate);
      if (dayIndex !== -1) {
        this.current_day = dayIndex;
        console.log('[CalendarComponent] Found pending event day index:', dayIndex);
      } else {
        // Fallback: find by day number only
        const fallbackIndex = this.raspon_datuma.findIndex(obj => obj.dan_enum == eventDay);
        if (fallbackIndex !== -1) {
          this.current_day = fallbackIndex;
          console.log('[CalendarComponent] Found pending event day index (fallback):', fallbackIndex);
        } else {
          this.current_day = first_day + moment().date() - 1;
        }
      }
    } else if (this.$store.state.event_details.selected_day != null && (this.$store.state.last_page_name == "EditProjectEvent" || this.$store.state.last_page_name == "EditPersonalEvent" || this.$store.state.last_page_name == "EditCaseEvent")) {
      this.current_day = this.$store.state.event_details.selected_day;
      this.select_event_type = this.$store.state.event_details.selected_type;
    }
    else {
      this.current_day = first_day + moment().date() - 1;
    }
    await ms_calendar.getEventType().then((resp) => {
      resp.data.map((ev) => this.filter_event_type.push({ naziv: ev.name, id: ev.uid }));
    });
    this.updateClickedClass(this.current_day);
    setTimeout(() => {
      this.$refs.paginat.paginirajOdabrane();
    }, 10);

    // Auto-open the pending event modal after calendar is fully rendered
    if (pendingEventId) {
      // Use $nextTick to wait for DOM update, then small delay for pagination to finish
      this.$nextTick(() => {
        setTimeout(async () => {
          await this.autoOpenPendingEvent(pendingEventId);
        }, 100);
      });
    }
  },
  computed: {
    computed_date() {
      let date_arr = this.chosen_date.split("-");
      return this.mjeseci[parseInt(date_arr[1] - 1)] + ', ' + date_arr[0] + '.';
    },
  },
  methods: {
    async generateReport() {
      this.fetching=true;
      // this.$store.state.rocista_report_data.events = this.all_events;
      this.$store.state.rocista_report_data.razdoblje =  
        this.$store.state.current_selected_case != undefined && this.$store.state.current_selected_case!=null 
        ? this.$store.state.current_selected_case.ime_predmeta : 'Ročišta predmeta';
      await ms_calendar.getPredmetnaRocista(this.$route.params.uid)
          .then((resp) => {
            console.log(resp.data);
            this.$store.state.rocista_report_data.events = resp.data;
            
            this.$store.state.current_report_type = 'predmetna_rocista'
            this.$router.push({ name: 'RocistaReport' });
          }).finally(()=>{this.fetching = false;});

    },
    is_permission_inside(wanted_permission,check_assistent) {
      return permissioner.check_case_permsision(wanted_permission,check_assistent)
    },
    openCreateEvent(dan) {
      console.log(dan);
      this.$store.state.chosen_date = dan.fullDate;
      console.log(this.$store.state.chosen_date)
      if (this.$route.name == "Calendar" || this.$route.name == 'KalendarProject') {
        if (this.is_permission_inside('case.calendar.create'), true)
          this.$router.push("kalendar/novi-dogadaj");
      } else {
        this.$router.push("/kalendar/novi-osobni-dogadaj")
      }
    },
    closePopup() {
      this.popup_open = false;
    },
    async autoOpenPendingEvent(eventId) {
      console.log('[CalendarComponent] Auto-opening pending event:', eventId, 'type:', typeof eventId);
      console.log('[CalendarComponent] Current day events (rasporedi_liste[0]):', this.rasporedi_liste[0]);

      // First, try to find the event in the already loaded day events
      let foundEvent = null;

      // Convert eventId to string for comparison (handles BigInt/number/string)
      const eventIdStr = String(eventId);

      // Search in day events list
      if (this.rasporedi_liste[0] && this.rasporedi_liste[0].length > 0) {
        foundEvent = this.rasporedi_liste[0].find(event => String(event.uid) === eventIdStr);
        console.log('[CalendarComponent] Searching in day events, found:', foundEvent);
      }

      // Also search in the current day's date_events from raspon_datuma
      if (!foundEvent && this.raspon_datuma[this.current_day]) {
        const dayEvents = this.raspon_datuma[this.current_day].date_events;
        console.log('[CalendarComponent] Searching in raspon_datuma[current_day].date_events:', dayEvents);
        if (dayEvents && dayEvents.length > 0) {
          foundEvent = dayEvents.find(event => String(event.uid) === eventIdStr);
          console.log('[CalendarComponent] Found in raspon_datuma:', foundEvent);
        }
      }

      // If found in local data, use it directly
      if (foundEvent) {
        console.log('[CalendarComponent] Using locally found event:', foundEvent);
        this.$store.state.event_details.chosen_event = foundEvent;
        this.$store.state.event_details.popup_open = true;
        return;
      }

      // Fallback: fetch from API
      try {
        console.log('[CalendarComponent] Event not found locally, fetching from API...');
        const response = await ms_calendar.getSingleEvent(eventId);
        const fullEventData = response.data;

        console.log('[CalendarComponent] Fetched event data from API:', fullEventData);

        // Open the modal via store
        this.$store.state.event_details.chosen_event = fullEventData;
        this.$store.state.event_details.popup_open = true;
      } catch (error) {
        console.error('[CalendarComponent] Error fetching event for auto-open:', error);
      }
    },
    cleanClasses() {
      this.raspon_datuma.forEach((dan) => {
        dan.classes = dan.classes.replace("week", "");
        dan.classes = dan.classes.replace("today", "");
      });
    },

    //nedjelja je nula
    //ponedjeljak ima vrijednost 1
    updateClickedClass(list_idx) {
      //CLEAN values for day and week
      this.rasporedi_liste[0] = [];
      this.rasporedi_liste[1] = [];

      //Očisti sve klase
      this.cleanClasses();
      this.raspon_datuma[list_idx].classes =
        this.raspon_datuma[list_idx].classes + " today";
      moment.locale(this.$i18n.locale);
      let clicked_day = parseInt(
        moment(this.raspon_datuma[list_idx].fullDate).day()
      );

      // console.log("clicked day " + clicked_day);
      var end_idx = 0;
      var start_idx = 0;
      var kvocijent = Math.floor(list_idx / 7);
      start_idx = kvocijent * 7;
      end_idx = start_idx + 6;
      this.getDayEventList(list_idx);
      this.getMonthEventList(start_idx, end_idx)

      this.current_day = list_idx;
      this.shown_date = moment(this.raspon_datuma[this.current_day].fullDate).format("DD.MM.YYYY")
      // console.log(this.is_clicked_on_calendar);
      if (this.is_clicked_on_calendar) {
        this.kategorija_liste = 1;
      }

      switch (this.kategorija_liste) {
        case 1:
          this.cleanClasses();
          this.selectDay(this.current_day);
          break;
        case 2:
          this.cleanClasses();
          this.selectWeekRange(start_idx, end_idx);
          this.selectDay(this.current_day);
          break;
        case 3:
          this.selectMonthRange();
          break;
        default:
          break;
      }
      setTimeout(() => {
        this.$refs.paginat.calculatePageNumber();
        this.$refs.paginat.paginirajOdabrane();
      }, 10);
    },
    async updateRasponDatuma() {
      this.fetching = true;
      this.finalni_arr_prikaza = [];
      (this.rasporedi_liste = [[], [], []]), (this.raspon_datuma = []);
      if (this.$route.name == "Calendar") {
        this.$store.state.paginacija.title = this.$t("breadcrumbs.case_single");
        await ms_calendar
          .getCallendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            this.$route.params.uid,
            this.select_event_type,
            'case'
          )
          .then((resp) => {
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
            this.fetching = false;
          });
      }
      else if (this.$route.name == "KalendarProject") {
        this.$store.state.paginacija.title = this.$t("breadcrumbs.proj_single");
        await ms_calendar
          .getCallendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            this.$route.params.uid,
            this.select_event_type,
            'project'
          )
          .then((resp) => {
            console.log(resp.data);
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
            this.fetching = false;
          });
      }
      else {
        this.$store.state.paginacija.title = this.$t("breadcrumbs.time_mgmt");
        let lawyer_id = await person.getSelf(this.accessToken);
        lawyer_id = lawyer_id.data.uid;

        await ms_calendar
          .getPersonCalendar(
            this.accessToken,
            this.selected_year,
            this.selected_month,
            lawyer_id,
            this.select_event_type,
            this.select_source_type
          )
          .then((resp) => {
            // console.log(resp.data);
            this.raspon_datuma = resp.data.raspon_datuma;
            this.rasporedi_liste[2] = resp.data.filled_dates;
            this.fetching = false;
          });
      }
      // console.log(this.raspon_datuma);
    },
    //update list of selected day events START
    selectMonthRange() {
      this.shown_date = this.computed_date;
      //Vrati index elementa u rasponu datuma s prvim danom u mjesecu
      var first_idx = this.raspon_datuma.findIndex(obj => obj.dan_enum == 1 || obj.dan_enum == 2);
      //postavi max vrijednost na vrijednost prvog dana u mjesecu
      var max_el_val = this.raspon_datuma[first_idx].dan_enum;
      //inicijaliziraj index zadnjeg dana u mjesecu na index prvog dana
      var last_idx = first_idx;
      //prolazi kroz raspon datuma dok se ne dodje do zadnjeg dana i spremi index zadnjeg dana
      for (let index = first_idx + 1; index < this.raspon_datuma.length; index++) {
        if (this.raspon_datuma[index].dan_enum > max_el_val) {
          //spremi vrijedost max elementa
          max_el_val = this.raspon_datuma[index].dan_enum
          //spremi trenutni najveći index
          last_idx = index;
        } else {
          break;
        }
      }
      for (let start_idx = first_idx; start_idx <= last_idx; start_idx++) {
        this.raspon_datuma[start_idx].classes =
          this.raspon_datuma[start_idx].classes + " week";
      }
    },

    selectWeekRange(start_idx, end_idx) {
      this.shown_date = moment(this.raspon_datuma[start_idx].fullDate).format("DD.MM.YYYY") + ' - ' + moment(this.raspon_datuma[end_idx].fullDate).format("DD.MM.YYYY")
      for (start_idx; start_idx <= end_idx; start_idx++) {
        this.raspon_datuma[start_idx].classes =
          this.raspon_datuma[start_idx].classes + " week";
      }
    },
    selectDay(day) {
      this.raspon_datuma[day].classes =
        this.raspon_datuma[day].classes + " today";
    },
    getDayEventList(day_idx) {
      this.rasporedi_liste[0] = this.raspon_datuma[day_idx].date_events;
    },

    getMonthEventList(strt_d, end_d) {
      for (var i = strt_d; i <= end_d; i++) {
        this.rasporedi_liste[1] = this.rasporedi_liste[1].concat(this.raspon_datuma[i].date_events);
      }
    },
    async changeDate() {
      let date_arr = this.chosen_date.split("-");
      this.selected_month = parseInt(date_arr[1] - 1);
      this.selected_year = parseInt(date_arr[0]);
      this.kategorija_liste = 2;
      this.kategorija_liste = 3;
      await this.updateRasponDatuma();
      this.is_clicked_on_calendar = false;
      this.updateClickedClass(this.current_day);
      this.is_clicked_on_calendar = true;
    },
    async changeDateDay() {
      let date_arr = this.chosen_date.split("-");
      this.selected_month = parseInt(date_arr[1] - 1);
      this.selected_year = parseInt(date_arr[0]);
      await this.updateRasponDatuma();
    },
    prevMonth() {
      this.chosen_date = moment(this.chosen_date).subtract(1, "M").format("YYYY-MM");
      this.changeDate();
    },
    nextMonth() {
      this.chosen_date = moment(this.chosen_date).add(1, "M").format("YYYY-MM");
      this.changeDate();
    },
    async prevDay() {
      if (this.current_day - 1 < 0) {
        let this_day = this.shown_date.split(".")[0];
        this.chosen_date = moment(this.chosen_date).subtract(1, "M").format("YYYY-MM");
        await this.changeDateDay();
        if (this_day != 1 && this_day != 2) {
          var last_day = this.raspon_datuma.find((day) => this_day - 1 == day.dan_enum);
          var last_idx = this.raspon_datuma.findIndex(obj => obj.dan_enum == 10);
          while (last_day.dan_enum > this.raspon_datuma[last_idx].dan_enum) {
            last_idx++;
          }
          this.current_day = last_idx;
        } else {
          this.current_day = this.raspon_datuma.length - 1;
        }

        this.kategorija_liste = 1;
        this.updateClickedClass(this.current_day);
      }
      else {
        this.updateClickedClass(this.current_day - 1)
      }
    },
    async nextDay() {
      console.log(this.raspon_datuma);
      if (this.current_day + 1 > this.raspon_datuma.length - 1) {
        this.chosen_date = moment(this.chosen_date).add(1, "M").format("YYYY-MM");
        await this.changeDateDay();
        let newDate = moment(this.shown_date, "DD.MM.YYYY").add(1, "days")
        var last_idx = this.raspon_datuma.findIndex(obj => obj.dan_enum == newDate.date());
        this.updateClickedClass(last_idx);
      }
      else {
        this.updateClickedClass(this.current_day + 1)
      }
    },
    async prevWeek() {
      var end_idx = 0;
      var start_idx = 0;
      if (this.current_day - 7 >= 0) {
        this.current_day -= 7;
        var kvocijent = Math.floor(this.current_day / 7);
        start_idx = kvocijent * 7;
        end_idx = start_idx + 6;
      } else {
        this.chosen_date = moment(this.chosen_date).subtract(1, "M").format("YYYY-MM");
        await this.changeDateDay();
        let found_less_10 = this.raspon_datuma.slice(28).find((dat) => dat.dan_enum < 10)
        if (found_less_10 != undefined) {
          var remaining_days = 14 - this.current_day - 1;
        } else {
          var remaining_days = 7 - this.current_day - 1;
        }
        this.current_day = this.raspon_datuma.length - 1 - remaining_days;
        var kvocijent = Math.floor(this.current_day / 7);
        start_idx = kvocijent * 7;
        end_idx = start_idx + 6;

      }
      this.is_clicked_on_calendar = false;
      this.updateClickedClass(this.current_day);
      this.is_clicked_on_calendar = true;
      this.selectWeekRange(start_idx, end_idx);
      this.selectDay(this.current_day);
    },
    async nextWeek() {
      var end_idx = 0;
      var start_idx = 0;
      if (this.current_day + 7 <= this.raspon_datuma.length - 1) {
        this.current_day += 7;
        var kvocijent = Math.floor(this.current_day / 7);
        start_idx = kvocijent * 7;
        end_idx = start_idx + 6;
      } else {
        this.chosen_date = moment(this.chosen_date).add(1, "M").format("YYYY-MM");
        await this.changeDateDay();
        let found_more_10 = this.raspon_datuma.slice(0, 7).find((dat) => dat.dan_enum > 20)
        if (found_more_10 != undefined) {
          var remaining_days = Math.abs(28 - this.current_day) + 7;
        } else {
          var remaining_days = Math.abs(28 - this.current_day);
        }
        this.current_day = remaining_days;
        var kvocijent = Math.floor(this.current_day / 7);
        start_idx = kvocijent * 7;
        end_idx = start_idx + 6;
      }

      this.is_clicked_on_calendar = false;
      this.updateClickedClass(this.current_day);
      this.is_clicked_on_calendar = true;
      this.selectWeekRange(start_idx, end_idx);
      this.selectDay(this.current_day);
    },
  },
  destroyed() {
    gsap.to(".router-wrapper", 0.5, {
      filter: "none",
      opacity: 1,
    });
    this.$store.state.event_details.popup_open = false;
  },
};

</script>

<style>

</style>